import { APIEndpoint } from ".";
import { AttributionData } from "../utils/attribution";
import { BillingPlan } from "../utils/subscriptionPlan";

export const subscribe = async (
  plan: BillingPlan,
  metaEventId?: string,
  attribution?: AttributionData
) => {
  return fetch(APIEndpoint + "/subscriptions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      plan,
      referral: window?.promotekit_referral,
      metaEventId,
      attribution,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.success === true) {
        return res;
      } else {
        return res;
      }
    })
    .catch((e) => {
      console.log("API Call, error subscribing", e);
    });
};
